const playSound = (url: string): void => {
  const audio = new Audio(url);
  audio.play();
};

export default playSound;
